<template>
    <div class="row panel-body">

        <div class="row">
            <div class="col-xs-5">
                <label>&nbsp;</label>
                <button type="button" v-if="isAdmin" @click="approveAll()" class="btn btn-default text-success form-control">
                    <i class="fa fa-check"></i> Check All
                    <small class="text-muted">(only for administrators)</small>
                </button>
            </div>
            <div class="col-xs-4" v-if="otherLanguages">
                <label>Reference Language</label>
                <select class="form-control" id="second-lang-col">
                    <option v-for="(language, otherLocale) in otherLanguages" :value="otherLocale">{{language}}</option>
                </select>
            </div>
        </div>

        <form method="post" ref="form">
            <input type="hidden" name="_token" :value="csrfToken"/>
            <input type="hidden" name="rejected[]" v-for="qid in rejected" :value="qid">
            <input type="hidden" name="approved[]" v-for="qid in approved" :value="qid">
            <quiz-translation-proof-question
                    v-for="(question, idx) in questions"
                    v-on:forceUpdate="forceUpdate()"
                    v-on:approve="(qid, shouldBeApproved) => {toggleApprove(qid, shouldBeApproved)}"
                    v-on:reject="(qid, shouldBeRejected) => {toggleReject(qid, shouldBeRejected)}"
                    ref="questions"
                    :idx="idx"
                    :key="question.qid"
                    :qid="question.qid"
                    :type="question.type"
                    :level="question.level"
                    :suggestedAnswerOid="question.suggestedAnswerOid"
                    :locale="locale"
                    :languageName="languageName"
                    :XX_en="question.text.XX_en"
                    :otherQuestions="otherQuestions[idx]"
                    :otherLanguages="otherLanguages"
                    :itranslation="question.text[locale]"
                    :ioptions="question.options"
                    :pictureUrl="question.pictureUrl"
                    :disabled="isDisabled(question.qid)"
                    :is-approved="isApproved(question.qid)"
                    :is-rejected="isRejected(question.qid)"
            ></quiz-translation-proof-question>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default" name="submit-save" @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button :disabled="!canSubmit"
                                   :title="canSubmit ? 'Submit' : 'You need to approve all questions'">
                    </submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: {
            'questionsJson': String,
            'otherQuestionsJson': String,
            'otherLanguagesJson': String,
            'rejectedJson': String,
            'approvedJson': String,
            'saveRoute': String,
            'rejectionComment': String,
            'wasRejected': Boolean,
            'isAdmin': Boolean,
            'locale': String,
            'languageName': String,
        },

        data: function() {
            return {
                questions: [],
                otherQuestions: JSON.parse(this.otherQuestionsJson),
                otherLanguages: JSON.parse(this.otherLanguagesJson),
                rejected: JSON.parse(this.rejectedJson),
                approved: JSON.parse(this.approvedJson),
                disabled: this.wasRejected ? JSON.parse(this.approvedJson) : [],
                csrfToken: window.csrfToken,
                updateTrigger: false,
                rejectionMessage: this.rejectionComment,
                autosaveCache: '',
            };
        },

        computed: {
            canSubmit: function() {
                if (this.updateTrigger) {
                    let rejectionCommentMissing = this.rejected.length > 0 && this.rejectionMessage.trim().length === 0;
                    let choicesCompleted = (this.approved.length + this.rejected.length === this.questions.length);

                    // check if all text fields are filled
                    let allQuestionsValid = true;
                    for (let index in this.$refs.questions) {
                        allQuestionsValid = this.$refs.questions[index].validate() && allQuestionsValid;
                    }

                    return !rejectionCommentMissing && choicesCompleted && allQuestionsValid;
                } else {
                    return false;
                }
            },
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            for (let idx in questions) {
                if (!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                this.questions.push(questions[idx]);
            }

            this.updateTrigger = true;
            this.forceUpdate();
            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer();
        },

        methods: {
            approveAll: function() {
                for (let idx in this.$refs.questions) {
                    if (!this.$refs.questions[idx].approved) {
                        this.$refs.questions[idx].approve();
                    }
                }
            },

            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
            },

            isDisabled(qid) {
                return this.disabled.indexOf(qid) > -1;
            },

            isApproved(qid) {
                return this.approved.indexOf(qid) > -1;
            },

            isRejected(qid) {
                return this.rejected.indexOf(qid) > -1;
            },

            toggleReject(qid, shouldBeRejected) {
                // if you click on "reject", the question should certainly not be approved anymore
                if (this.isApproved(qid)) {
                    this.approved.splice(this.approved.indexOf(qid), 1);
                }

                if (shouldBeRejected && !this.isRejected(qid)) {
                    this.rejected.push(qid);
                } else if (!shouldBeRejected && this.isRejected(qid)) {
                    this.rejected.splice(this.rejected.indexOf(qid), 1);
                }
            },

            toggleApprove(qid, shouldBeApproved) {
                // if you click on "approve", the question should certainly not be rejected anymore
                if (this.isRejected(qid)) {
                    this.rejected.splice(this.rejected.indexOf(qid), 1);
                }

                if (shouldBeApproved && !this.isApproved(qid)) {
                    this.approved.push(qid);
                } else if (!shouldBeApproved && this.isApproved(qid)) {
                    this.approved.splice(this.approved.indexOf(qid), 1);
                }
            },

            autosaveTimer() {
                setTimeout(() => {
                    this.autosave();
                    this.autosaveTimer();
                }, 60000); // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize();

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message);
                }).catch(() => {
                    toastr.error('Something went wrong...', message);
                });
            },
        },
    };
</script>
